import type { CityConfig } from "../city-template/types";

export const rivertonConfig: CityConfig = {
  city: "Riverton",
  state: "Wyoming",
  stateAbbr: "WY",
  slug: "riverton",
  route: "/cities/riverton",
  title: "Emergency Passport Riverton, WY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Riverton, WY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Riverton, Lander, Wind River Indian Reservation, and Fremont County travelers. Denver 380 miles — we come to you.",
  h1: "Emergency & Expedited Passport Services in Riverton, WY",
  heroSubtitle: "Central Wyoming College student heading abroad? Wind River Indian Reservation family planning international travel? Fremont County agricultural professional with overseas business? We help Riverton residents — from Wind River Valley families to CWC students to Fremont County ranchers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Riverton%20Wyoming%20with%20the%20Wind%20River%20Valley%20stretching%20toward%20the%20Wind%20River%20Mountains%20on%20the%20distant%20horizon%2C%20the%20wide-open%20high%20plains%20landscape%20with%20sagebrush%20and%20dramatic%20cloud%20formations%2C%20the%20Big%20Wind%20and%20Little%20Wind%20rivers%20converging%20near%20town%20under%20a%20vast%20Wyoming%20sky%20at%20golden%20hour%2C%20editorial%20Western%20photography%20with%20warm%20natural%20colors%20and%20expansive%20frontier%20atmosphere&width=1800&height=700&seq=riverton-hero-2026&orientation=landscape",
  heroImageAlt: "Riverton Wyoming with Wind River Valley and Wind River Mountains in the distance",
  geoPosition: "43.0250;-108.3800",
  geoPlacename: "Riverton, Wyoming",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 380 miles from Riverton via US-26 and I-25; a 6.5+ hour drive one way",
  },
  nearbyCitiesZips: [
    { name: "Riverton", zips: "82501" },
    { name: "Lander", zips: "82520" },
    { name: "Hudson", zips: "82515" },
    { name: "Pavillion", zips: "82523" },
    { name: "Shoshoni", zips: "82649" },
    { name: "Kinnear", zips: "82516" },
    { name: "Fort Washakie", zips: "82514" },
    { name: "Arapahoe", zips: "82510" },
  ],
  benefits: [
    { icon: "ri-landscape-line", title: "Wind River Valley & Central Wyoming Hub", desc: "Riverton sits at the heart of the Wind River Valley, where the Big Wind and Little Wind rivers converge beneath the Wind River Mountains. As the largest town in Fremont County, Riverton serves as a commercial and travel hub for central Wyoming's diverse communities." },
    { icon: "ri-global-line", title: "Wind River Indian Reservation Connections", desc: "Riverton borders the Wind River Indian Reservation, home to the Eastern Shoshone and Northern Arapaho tribes. Many tribal members travel internationally for cultural exchanges, conferences, and family visits — creating unique passport needs we understand and serve with cultural sensitivity." },
    { icon: "ri-flight-takeoff-line", title: "RIW — Central Wyoming Regional Airport", desc: "RIW connects to Denver International Airport via United Express. DIA is the major international gateway for the region. We coordinate passport timelines around RIW connections through Denver and beyond." },
    { icon: "ri-building-2-line", title: "Central Wyoming College & Educational Travel", desc: "CWC in Riverton serves students from across the Wind River region and beyond. Study abroad programs, international student travel, and faculty research create regular passport needs that require fast, reliable processing." },
    { icon: "ri-home-2-line", title: "Agriculture & Energy Industry Professionals", desc: "Fremont County's agricultural and energy sectors have international dimensions — from beef exports to international energy conferences. Riverton professionals traveling overseas for business need passport readiness without the 380-mile Denver trip." },
  ],
  internalLinks: [
    { name: "Expedited passport in Casper, WY", route: "/cities/casper" },
    { name: "Fast passport in Laramie, WY", route: "/cities/laramie" },
    { name: "Quick passport in Rock Springs, WY", route: "/cities/rock-springs" },
    { name: "Urgent passport in Cheyenne, WY", route: "/cities/cheyenne" },
    { name: "Wyoming passport services overview", route: "/states/wyoming" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Riverton via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 6.5+ hours to Colorado. Riverton residents can ship from any UPS Store, FedEx Office, or post office location across Fremont County.",
  fpcOfficeDistance: "Serving Riverton, Lander, Hudson, Pavillion, Shoshoni, Kinnear, Fort Washakie, Arapahoe, and all Fremont County and Wind River Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Riverton and Fremont County. From the Wind River Valley farmlands to the Wind River Indian Reservation communities, from Central Wyoming College to the energy and agricultural businesses — we serve all of central Wyoming. Our courier service eliminates the need to drive to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Riverton and all Fremont County communities including Lander, Hudson, and Shoshoni. We also serve Wind River Indian Reservation residents and CWC students and faculty planning international travel.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Riverton as simple as possible — with the reliability Wind River Valley families, CWC students, and Fremont County professionals need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Riverton travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Riverton travelers encounter unique passport issues — from Wind River Indian Reservation documentation requirements to CWC study abroad deadlines to Fremont County rural address verification. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Central Wyoming travelers — from Wind River Valley ranching families to Central Wyoming College students to Wind River Indian Reservation community members — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Riverton, WY? Here are the most common ones we hear from Fremont County travelers.",
  statePageRoute: "/states/wyoming",
  statePageName: "Wyoming",
  servicesIntro: "Whether you need a renewal before a RIW connection to Denver, an emergency passport for a last-minute family trip, or a first-time passport for a CWC study abroad program — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.state.wy.us/driverservices",
  dmvLabel: "Wyoming Department of Transportation — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 380 miles from Riverton", "6.5+ hour drive — completely impractical for Fremont County residents", "No other regional agency within a day's drive"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — we handle everything remotely", "Ideal for Wind River Valley families and CWC students", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Riverton or Lander", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "RIW connection for a Wind River Valley family emergency? Last-minute CWC student trip abroad? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Riverton travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Riverton residents renew fast — no agency visit required. Perfect for Fremont County ranch families and Wind River Valley professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Fremont County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your travel plans stay on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions for your Fremont County family trip abroad.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Fremont County agricultural professionals and energy industry workers with international contracts.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Riverton travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Riverton residents crossing into Canada through Montana.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Riverton WY", description: "Urgent passport processing for Riverton Wyoming travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Riverton WY", description: "Fast passport renewal for Riverton Wyoming residents with a previously-issued passport." },
    { name: "First-Time Passport Riverton WY", description: "New passport application services for Riverton Wyoming residents applying for their first passport." },
    { name: "Child Passport Riverton WY", description: "Minor passport services for Riverton Wyoming families with children under 16." },
    { name: "Name Change Passport Riverton WY", description: "Passport name correction after marriage, divorce, or legal name changes for Riverton residents." },
    { name: "Second Passport Riverton WY", description: "Second passport services for Riverton frequent travelers and business professionals." },
  ],
  testimonials: [
    {
      name: "Sarah J.",
      location: "Riverton",
      rating: 5,
      text: "CWC nursing student with a study abroad opportunity in Costa Rica. Two weeks to get my passport renewed. Fast Passport Center got it done in 6 days and I made the trip. Driving to Denver — 380 miles — was never going to happen around my class schedule. This service is a lifesaver for students in central Wyoming.",
      service: "Passport Renewal — Student",
    },
    {
      name: "The LoneBear Family",
      location: "Fort Washakie",
      rating: 5,
      text: "Family trip for a cultural exchange to New Zealand. Needed first passports for our kids and a renewal for us. Fast Passport Center handled everything with care and attention to detail. Understood our timeline and got all four passports back in 8 days. Remarkable service for Wind River Reservation families.",
      service: "Family — New Passports & Renewals",
    },
    {
      name: "Tom H.",
      location: "Riverton",
      rating: 5,
      text: "Fremont County cattle producer heading to an international beef expo in Calgary. Passport had expired during COVID and I didn't realize until 10 days before the trip. Fast Passport Center expedited my renewal in 5 days. Without them, I'd have missed a major business opportunity.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Maria D.",
      location: "Pavillion",
      rating: 5,
      text: "Family emergency in Mexico — needed a passport in 72 hours. Fast Passport Center made it happen. When you live in central Wyoming, you feel isolated from services like this, but they proved that geography doesn't matter with the right courier. Forever grateful.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "riverton-1",
      name: "Riverton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 E Main St",
      city: "Riverton",
      state: "WY",
      zip: "82501",
      phone: "(307) 856-7164",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Downtown Riverton",
      website: "https://tools.usps.com/find-location.htm?location=1378525",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Fremont County's largest city. Appointments fill during summer tourist and student travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "riverton-2",
      name: "Fremont County Clerk of District Court — Riverton",
      type: "County Clerk Passport Acceptance",
      address: "450 N 2nd St, Room 220",
      city: "Riverton",
      state: "WY",
      zip: "82501",
      phone: "(307) 332-1134",
      hours: "Mon–Fri 7:30 AM – 4:30 PM",
      distance: "Riverton — Fremont County Courthouse Annex",
      website: "https://fremontcountywy.gov/",
      websiteLabel: "Fremont County Website",
      notes: "Alternative to post office acceptance facilities. Also serves as the county seat facility for Lander-area residents. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "riverton-3",
      name: "Lander Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "230 Grandview Dr",
      city: "Lander",
      state: "WY",
      zip: "82520",
      phone: "(307) 332-2345",
      hours: "Mon–Fri 8:30 AM – 4:00 PM (appointment required)",
      distance: "Lander — about 25 miles southwest of Riverton via US-287",
      website: "https://tools.usps.com/find-location.htm?location=1368488",
      websiteLabel: "USPS Location",
      notes: "Serves the Lander community and southern Fremont County. Good alternative when Riverton appointments are fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "riverton-4",
      name: "Central Wyoming College — Student Services",
      type: "Campus Passport Services",
      address: "2660 Peck Ave",
      city: "Riverton",
      state: "WY",
      zip: "82501",
      phone: "(307) 855-2115",
      hours: "Mon–Fri 8:00 AM – 5:00 PM (limited passport services — call for availability)",
      distance: "CWC Campus — west Riverton",
      website: "https://www.cwc.edu/",
      websiteLabel: "CWC Website",
      notes: "Limited passport services for students and staff. Call ahead to confirm current passport acceptance availability, especially during summer term.",
      icon: "ri-government-line",
    },
    {
      id: "riverton-5",
      name: "Shoshoni Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "103 E 2nd St",
      city: "Shoshoni",
      state: "WY",
      zip: "82649",
      phone: "(307) 876-2515",
      hours: "Mon–Fri 8:00 AM – 12:00 PM, 1:00 PM – 4:00 PM (appointment required)",
      distance: "Shoshoni — about 20 miles northeast of Riverton via US-26",
      website: "https://tools.usps.com/find-location.htm?location=1379894",
      websiteLabel: "USPS Location",
      notes: "Limited hours — morning appointments only. Useful for northern Fremont County and southern Hot Springs County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 380 miles and 6.5+ hour drive from Riverton one way", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 13+ hour round trip from Riverton", fpc: "Most Riverton travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, especially problematic from rural central Wyoming", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Riverton Residents", agency: "380-mile drive to Denver — completely impractical for Fremont County residents", fpc: "Entirely remote — forms online, ship from Riverton, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in 13+ hours of driving, time off work, and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Fremont County Context", agency: "No Riverton-specific guidance — no Wind River Valley, CWC, or tribal community expertise", fpc: "Full Fremont County knowledge — Wind River Indian Reservation, CWC, agricultural and energy sectors" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Wind River Indian Reservation Documentation Mismatches",
      description: "Tribal IDs and Bureau of Indian Affairs documentation may use different name formats or addresses than what appears on other identification. We help Wind River Indian Reservation residents navigate these documentation requirements to ensure smooth passport processing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "CWC Study Abroad Deadline Misalignment",
      description: "Central Wyoming College students often underestimate passport processing timelines for study abroad programs. Semester abroad applications may require passport numbers 4-6 months before departure. Start passport processes when you apply, not when you're accepted.",
    },
    {
      icon: "ri-error-warning-line",
      title: "RIW Connection Timing to Denver International",
      description: "RIW flights to Denver connect to international flights at DIA. An expired or near-expired passport will prevent boarding at RIW even if your international flight from Denver is hours later. Check your passport before booking any itinerary through RIW.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Fremont County Rural Address Documentation",
      description: "Ranch addresses, rural route numbers, and addresses on the Wind River Indian Reservation may differ from what appears on driver's licenses and other supporting documents. We review all documentation to catch address mismatches before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards from Central Wyoming Retailers",
      description: "Passport photos from smaller retailers in Riverton, Lander, and Hudson may not meet strict State Department standards for lighting, background, and sizing. We review photos before submission to prevent rejection.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether a CWC study abroad program, Wind River Valley family trip, or Fremont County business travel." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — tribal community member, CWC student, or Fremont County professional." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Riverton clients ship from the Riverton Post Office on Main Street or the UPS Store in town." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Riverton travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Riverton, Lander, or Fremont County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Riverton, Wyoming?", a: "We offer Riverton-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest regional passport agency is in Denver (380 miles away) — our remote courier service is the only practical fast option in central Wyoming." },
    { q: "Do I need to visit a Riverton office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Riverton Post Office or Fremont County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Fremont County address." },
    { q: "Where can I get passport acceptance near Riverton?", a: "Riverton has acceptance facilities at the Main Post Office on Main Street and the Fremont County Clerk. Nearby options include USPS locations in Lander and Shoshoni. We maintain an updated list of Fremont County-area facilities." },
    { q: "I'm a Central Wyoming College student — can you help with study abroad passport needs?", a: "Yes. CWC students heading abroad for study programs, exchanges, or international conferences need timely passport processing. We help CWC students navigate the process with clear checklists and fast expedited service, coordinating around class schedules and semester deadlines." },
    { q: "Can you help Wind River Indian Reservation residents with passport applications?", a: "Absolutely. We have experience working with Eastern Shoshone and Northern Arapaho tribal members on the Wind River Indian Reservation. We understand the unique documentation considerations including tribal IDs, Bureau of Indian Affairs records, and can guide you through any special requirements." },
    { q: "How does RIW airport connect to international flights?", a: "Central Wyoming Regional Airport (RIW) connects to Denver International Airport via United Express. DIA offers direct international flights worldwide. Your passport must be valid when you check in at RIW, as you are ticketed through to your international destination." },
    { q: "What is the best price for expedited passport service in Riverton?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Riverton applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent. We provide a Riverton-specific checklist." },
    { q: "Can I get a passport photo in Riverton?", a: "Yes. The Riverton Post Office offers limited on-site passport photos. Smith's Food & Drug, Walmart Supercenter, and local pharmacies also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What if winter weather delays my overnight shipping from Riverton?", a: "Central Wyoming winters can affect shipping timelines, especially during major snow events that impact US-26 and US-287. We recommend building in 1-2 extra buffer days during winter months (November through March) when planning expedited passport timelines from the Wind River Valley." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Riverton Residents",
    intro: "Riverton's position at the heart of the Wind River Valley, with access to both the Wind River Indian Reservation and Central Wyoming College, creates unique passport timing considerations. Here's what Fremont County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "RIW — Central Wyoming Regional Airport",
        subtitle: "The essential first leg for Wind River Valley international travel",
        description: "RIW connects to Denver International Airport via United Express regional jet service. From DIA, travelers access direct flights to Europe, Asia, and Latin America. The critical insight: your passport is checked at RIW check-in, not at DIA. If your passport isn't valid, you won't board in Riverton.",
        tip: "Check your passport expiration when you book any itinerary departing from RIW. Winter weather in central Wyoming can delay RIW connections — build in buffer time for international itineraries, especially November through March.",
      },
      {
        icon: "ri-global-line",
        title: "Wind River Indian Reservation Travel Considerations",
        subtitle: "Cultural exchanges, conferences, and international family connections",
        description: "The Wind River Indian Reservation, home to the Eastern Shoshone and Northern Arapaho tribes, has international connections spanning cultural exchanges, indigenous rights conferences, and family visits abroad. Tribal members traveling internationally may have documentation considerations that differ from standard passport application requirements.",
        tip: "Tribal members traveling internationally should begin passport processes early and ensure all identification documents — tribal IDs, BIA records, state IDs, and birth certificates — have consistent name formats and addresses. We help review all documentation before submission.",
      },
      {
        icon: "ri-landscape-line",
        title: "Wind River Valley & Outdoor Recreation Access",
        subtitle: "The gateway to the Wind River Mountains and outdoor adventure",
        description: "Riverton sits at the eastern edge of the Wind River Valley, with the Wind River Mountains — home to the highest peaks in Wyoming — to the west. This location makes Riverton a base for outdoor enthusiasts who travel internationally for adventure tourism, from Patagonian treks to Himalayan expeditions to Canadian Rockies climbing.",
        tip: "Outdoor guides and adventure travelers should treat passport validity as essential equipment. International expedition bookings often require passport information 6+ months ahead, and last-minute replacements from rural Wyoming are far more stressful than simply renewing early.",
      },
      {
        icon: "ri-building-2-line",
        title: "Central Wyoming College & Academic Travel Rhythms",
        subtitle: "Study abroad, faculty research, and international student travel",
        description: "CWC serves students from across the Wind River region, including many from the Wind River Indian Reservation and rural Fremont County communities. Study abroad programs, faculty research trips, and international student travel create regular passport needs tied to the academic calendar.",
        tip: "CWC students should apply for passports during the fall semester for spring study abroad programs and during spring semester for summer/fall programs. Don't wait until acceptance — many programs require passport numbers with the application itself.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Riverton & the Wind River Valley",
      description: "Riverton is the commercial heart of the Wind River Valley, where the Big Wind and Little Wind rivers converge beneath the towering Wind River Mountains. As Fremont County's largest city, Riverton serves as a crossroads for central Wyoming's diverse communities — from the Wind River Indian Reservation to the agricultural lands of the valley floor. The annual Riverton Rendezvous and the 1838 Mountain Man Rendezvous site reflect a community proud of its Western heritage, while Central Wyoming College brings an educational energy that connects this frontier town to the wider world.",
    },
  },
  destinations: {
    title: "Where Riverton Travelers Go — And Why Passports Get Urgent",
    intro: "Riverton's identity as the commercial hub of the Wind River Valley, serving both agricultural communities and the Wind River Indian Reservation, shapes its international travel patterns.",
    stats: [
      { stat: "30%", label: "of Riverton expedited requests involve CWC study abroad or faculty travel" },
      { stat: "2–3 Weeks", label: "average lead time from trip booking to departure for Fremont County travelers" },
      { stat: "May–Aug", label: "peak season for Wind River Valley family travel and outdoor recreation" },
      { stat: "380 Miles", label: "to nearest passport agency in Denver — our courier service bridges this" },
    ],
    destinations: [
      { name: "Canada", context: "Fishing and hunting trips to Alberta and Saskatchewan, Calgary agricultural expos, Canadian Rockies outdoor recreation, cross-border family visits", urgency: "Seasonal outdoor recreation and agricultural expo bookings", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Winter getaways for Wind River Valley families, resort vacations, CWC study abroad programs, language immersion trips", urgency: "Winter vacation planning and academic program deadlines", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "CWC faculty research and sabbaticals, Wind River Valley family heritage travel, cultural exchange programs, agricultural conferences", urgency: "Fixed-date academic and conference schedules", icon: "ri-map-pin-2-line" },
      { name: "New Zealand & Australia", context: "Indigenous cultural exchanges, agricultural exchange programs, working holiday visas, adventure tourism", urgency: "Cultural exchange program timelines and seasonal work windows", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Agricultural and ranching exchanges, adventure tourism in Patagonia and the Andes, cattle industry connections to Argentina and Brazil", urgency: "Southern Hemisphere summer ranching and agricultural calendar", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Energy industry conferences, agricultural export markets, CWC international student travel, cultural tourism", urgency: "Business travel and academic calendar deadlines", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Wyoming Service Areas",
    crossLinksDesc: "We serve travelers across the Equality State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Casper", route: "/cities/casper" },
      { name: "Laramie", route: "/cities/laramie" },
      { name: "Rock Springs", route: "/cities/rock-springs" },
    ],
  },
  photoLocations: [
    { name: "Riverton Main Post Office", address: "501 E Main St, Riverton, WY 82501", hours: "Mon–Fri 9 AM – 3:30 PM (limited photo service)" },
    { name: "The UPS Store — Riverton", address: "1733 N Federal Blvd, Riverton, WY 82501", hours: "Mon–Fri 8:30 AM – 6 PM, Sat 10 AM – 2 PM" },
    { name: "Smith's Food & Drug — Riverton", address: "1200 W Main St, Riverton, WY 82501", hours: "Daily 6 AM – 11 PM" },
    { name: "Walmart Supercenter — Riverton", address: "1700 N Federal Blvd, Riverton, WY 82501", hours: "Daily 6 AM – 11 PM" },
    { name: "Walgreens — Riverton", address: "650 W Main St, Riverton, WY 82501", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Fremont County Treasurer — Motor Vehicle Division",
      address: "450 N 2nd St, Room 150, Riverton, WY 82501",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Wyoming DOT Driver Services — Lander",
      address: "125 Wyoming St, Lander, WY 82520",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver license examinations, REAL ID, and driving records for southern Fremont County. About 25 miles southwest of Riverton.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RIW",
      name: "Central Wyoming Regional Airport",
      distance: "About 3 miles northwest of downtown Riverton (5 minutes via US-26)",
      address: "200 Airport Rd, Riverton, WY 82501",
      note: "Connects to Denver International Airport via United Express. Free parking. The primary departure point for Wind River Valley international travelers.",
      flightUrl: "https://www.rivertonwy.gov/airport",
      flightLabel: "RIW Airport",
      featured: true,
    },
    {
      code: "CPR",
      name: "Casper-Natrona County International Airport",
      distance: "About 120 miles east of Riverton (2 hours via US-26 and I-25)",
      address: "8500 Airport Pkwy, Casper, WY 82604",
      note: "Larger regional airport with connections to Denver and Salt Lake City. Good alternative when RIW connections are limited or fully booked.",
      flightUrl: "https://www.iflycasper.com/",
      flightLabel: "Casper Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Wyoming birth certificates from the Wyoming Department of Health Vital Statistics Services. Online, mail, or in-person options available.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Wyoming Vital Statistics Services. Required for estate and legal matters in Fremont County.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Fremont County Clerk. Certified copies available for name changes and passport applications.",
      url: "https://fremontcountywy.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Fremont County District Court. Required for name change passport corrections.",
      url: "https://fremontcountywy.gov/",
    },
  ],
};